"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBootstrapAsync = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.fetchBootstrapAsync = (0, typesafe_actions_1.createAsyncAction)(constants_1.FETCH_BOOTSTRAP_REQUEST, constants_1.FETCH_BOOTSTRAP_REQUEST_SUCCESS, constants_1.FETCH_BOOTSTRAP_REQUEST_CANCEL, constants_1.FETCH_BOOTSTRAP_REQUEST_FAIL)();